var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('v-img',{staticClass:"footer-img",attrs:{"src":require('../../assets/footer.png'),"width":"100%","contain":""}}),_c('p',{staticClass:"copy-right"},[_vm._v("Copyright © Vollmond All Rights Reserved.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }